const songs = [
    {
        name: "Breeze",
        src: "./songs/2.mp3"
    },
    {
        name: "The Light",
        src: "./songs/1.mp3"
    },
    {
        name: "Fading Away",
        src: "./songs/3.mp3"
    },
    {
        name: "Your Name",
        src: "./songs/4.mp3"
    },
    {
        name: "Traveller",
        src: "./songs/5.mp3"
    },
    {
        name: "My Heart",
        src: "./songs/2.mp3"
    },
    {
        name: "Dusk",
        src: "./songs/5.mp3"
    }
]

export default songs